import { render, staticRenderFns } from "./AcpGroupDetail.vue?vue&type=template&id=08067936"
import script from "./AcpGroupDetail.vue?vue&type=script&lang=js"
export * from "./AcpGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports